import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import axios from "axios";
import { jwtDecode } from "jwt-decode";


export default function VerifyEmail() {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API;
  
  const [optsending, setOptSending] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
  });
  
  const [errors, setErrors] = useState({});
   const [memberCode, setmemberCode] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (!token) {
          navigate('/token/signin');
          return;
        }
      
        const validateToken = async () => {
          try {
            const response = await fetch(`${baseUrl}/validate-token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ token }),
            });
      
            const data = await response.json();
      
            if (!data.valid) {
              sessionStorage.removeItem('authToken'); // Optional cleanup
              navigate('/token/signin');
            }
          } catch (error) {
            console.error('Token validation failed:', error);
            sessionStorage.removeItem('authToken');
            navigate('/token/signin');
          }
        };
      
        validateToken();
      }, [navigate]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        setmemberCode(decoded.memberCode );
      } catch (error) {
        console.error("Invalid token", error);
      }
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSendOtp = async () => {
    setOptSending(true);
    if (!formData.email) {
      setErrors({ ...errors, email: "Email is required" });
      return;
    }
  
    setErrors({ ...errors, email: "" });
  
    try {
      const response = await axios.post(`${baseUrl}/auth/send-otp`, {
        email: formData.email,
      });
  
      if (response.data) {
        toast.success("OTP sent successfully.");
      }
      setOptSending(false);
    } catch (error) {
      console.error("Error sending OTP:", error.response?.data || error.message);
      setOptSending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.otp) newErrors.otp = "OTP is required";

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
    }

    setErrors({});

    try {
        const otpResponse = await axios.post(`${baseUrl}/auth/verify-otp`, {
            email: formData.email,
            otp: formData.otp,
        });

        if (otpResponse.data.otpVerified) {
            toast.success("Email verified successfully!");
            navigate("/token/rzto");
        } else {
            toast.error("Invalid OTP. Please try again.");
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || "Verification failed!";
        toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className="auth-background"></div>
      <div className="bg-overlay"></div>

      <div className="auth-container">
        <div className="auth-wrapper">
          <div className="auth-card">
            <h1 className="auth-title">Verify Your Email</h1>
            <p className="auth-subtitle">
              We'll send a verification code to your email
            </p>

            <form onSubmit={handleSubmit} className="auth-form">
              {/* Email */}
              <div className="form-group">
                <div className="input-with-icon">
                  <Icon icon="mdi:email-outline" className="input-icon" />
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                {errors.email && <p className="error-message">{errors.email}</p>}
              </div>

              {/* OTP */}
              <div className="form-group otp-group">
                <div className="input-with-icon">
                  <Icon icon="mdi:lock-outline" className="input-icon" />
                  <input
                    type="text"
                    name="otp"
                    className="form-input"
                    placeholder="Enter OTP"
                    value={formData.otp}
                    onChange={handleChange}
                  />
                </div>
                <button 
                  type="button" 
                  className="otp-button"
                  onClick={handleSendOtp}
                >
                  {optsending? 'Sending OTP': 'Send OTP'}
                </button>
                {errors.otp && <p className="error-message">{errors.otp}</p>}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="submit-button"
              >
                Verify Email
              </button>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .auth-background {
          background-image: url(/images/main-background.jpg);
          background-size: cover;
          background-position: center;
          min-height: 100vh;
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
          z-index: -1;
          filter: blur(10px);
        }
        
        .auth-container {
          width: 100%;
          min-height: calc(100vh - 80px);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          box-sizing: border-box;
        }
        
        .auth-wrapper {
          width: 100%;
          max-width: 500px;
        }
        
        .auth-card {
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .auth-title {
          font-size: 2rem;
          color: #333;
          text-align: center;
          margin-bottom: 10px;
        }
        
        .auth-subtitle {
          color: #666;
          text-align: center;
          margin-bottom: 30px;
        }
        
        .form-group {
          margin-bottom: 20px;
          position: relative;
        }
        
        .input-with-icon {
          position: relative;
        }
        
        .input-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #666;
          font-size: 1.2rem;
          z-index: 2;
        }
        
        .form-input {
          width: 100%;
          padding: 15px 15px 15px 45px;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 1rem;
          box-sizing: border-box;
          position: relative;
          z-index: 1;
        }
        
        .otp-group {
          position: relative;
        }
        
        .otp-button {
          position: absolute;
          right: 17px;
          top: 7px;
          background-color: #f0b90b;
          border: none;
          padding: 8px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 0.9rem;
          z-index: 2;
        }
        
        .submit-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background-color: #f0b90b;
          color: white;
          font-size: 1rem;
          cursor: pointer;
          margin-top: 10px;
          transition: background-color 0.3s;
        }
        
        .submit-button:hover {
          background-color: #e0a800;
        }
        
        .auth-redirect {
          text-align: center;
          margin-top: 20px;
          color: #666;
        }
        
        .auth-link {
          color: #f0b90b;
          text-decoration: none;
          font-weight: 600;
        }
        
        .auth-link:hover {
          text-decoration: underline;
        }
        
        .error-message {
          color: #dc3545;
          font-size: 0.8rem;
          margin-top: 5px;
          text-align: left;
          padding-left: 10px;
        }
        
        @media (max-width: 768px) {
          .auth-card {
            padding: 20px;
          }
          
          .auth-title {
            font-size: 1.5rem;
          }
          
          .form-input {
            padding: 12px 12px 12px 40px;
          }
          
          .input-icon {
            display:none;
          }
        }
        
        @media (max-width: 480px) {
          .auth-container {
            padding: 10px;
          }
          
          .auth-card {
            padding: 15px;
          }
          
          .form-input {
            padding: 10px 10px 10px 36px;
          }
          
          .otp-button {
            right: 12px;
            top: 12px;
            padding: 6px 10px;
            font-size: 0.8rem;
          }
        }
      `}</style>
    </>
  );
}